import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import user from './modules/user'
import firestore from './modules/firestore'
import lecturer from './modules/lecturer'
import student from './modules/student'

const vuexPersist = new VuexPersist({
  key: 'lessonSquared',
  storage: window.localStorage,
  modules: ['user'], //only save user module
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    firestore,
    lecturer,
    student
  },
  state: {
    snackbarMessage: null,
    dialogVisible: false,
    singletonGuards: []
  },
  getters: {
    snackbarMessage(state) {
      return state.snackbarMessage
    },
    dialogVisible(state) {
      return state.dialogVisible
    },
    singletonGuards(state) {
      return state.singletonGuards
    }
  },
  mutations: {
    SET_SNACKBAR_MESSAGE(state, message) {
      state.snackbarMessage = message
    },
    SET_DIALOG_VISIBILITY(state, visibility) {
      state.dialogVisible = visibility
    },
    ADD_SINGLETON_GUARD(state, guardName) {
      state.singletonGuards.push(guardName)
    },
    CLEAR_SINGLETON_GUARDS(state) {
      while(state.singletonGuards.length > 0) {
        state.singletonGuards.pop()
      }
    }
  },
  actions: {
    storeSnackbarMessage({ commit }, message) {
      commit("SET_SNACKBAR_MESSAGE", message)
    },
    hideDialog({ commit }) {
      commit("SET_DIALOG_VISIBILITY", false)
    },
    setDialogVisibility({ commit }, value) {
      commit("SET_DIALOG_VISIBILITY", value)
    }
  },
  plugins: [vuexPersist.plugin]
})
